module.exports = __webpack_public_path__ + "static/media/commerce.6fe01d80.jpg";